export default __webpack_public_path__ + "static/media/undraw_empty_cart_co35.5ea4c1a0.svg";